module.exports = __webpack_public_path__ + "static/media/cap-sri-lanka.23690c90.png";